import { render, staticRenderFns } from "./UserPartner.vue?vue&type=template&id=4fd29b2a&"
import script from "./UserPartner.vue?vue&type=script&lang=js&"
export * from "./UserPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports